<form [formGroup]="form">
  <div class="radio-wrapper" [ngClass]="'state_' + checkbox.value">
    <input type="radio" class="no" id="radio-no_{{key}}" [value]="false" formControlName="checkbox"/>
    <label for="radio-no_{{key}}">
      &nbsp;
    </label>

    <input type="radio" class="neutral" checked id="radio-neutral_{{key}}" [value]="null" formControlName="checkbox"/>
    <label for="radio-neutral_{{key}}">
      &nbsp;
    </label>

    <input type="radio" class="yes" id="radio-yes_{{key}}" [value]="true" formControlName="checkbox"/>
    <label for="radio-yes_{{key}}">
      &nbsp;
    </label>
  </div>
</form>
